module.exports = __webpack_public_path__ + "static/media/gauge.df266de9.svg";